/** Shown immediately on load; replaced when GET /api/rate succeeds. */
export const DEFAULT_PRIME_RATE = 4.45;
